import { Component, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { MfaMethodDisabledNotificationData } from '../../models/mfa';

export interface MfaMethodDisabledResult {
	action?: 'enroll' | 'continue';
	signedOut?: boolean;
}

@Component({
	selector: 'app-mfa-method-disabled',
	templateUrl: './mfa-method-disabled.component.html',
	styleUrls: ['./mfa-method-disabled.component.scss']
})
export class MfaMethodDisabledComponent implements OnDestroy {
	private destroy$ = new Subject<void>();

	constructor(
		public dialogRef: MatDialogRef<MfaMethodDisabledComponent>,
		@Inject(MAT_DIALOG_DATA) public data: MfaMethodDisabledNotificationData
	) {}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	get isEnforced(): boolean {
		return this.data.effectivePolicy === 2;
	}

	get isOptional(): boolean {
		return this.data.effectivePolicy === 1;
	}

	get hasAvailableMethods(): boolean {
		return this.data.allowedMethodsForEnrollment?.length > 0;
	}

	get disabledMethodDisplayNames(): string {
		return (this.data.disabledMethodNames || [])
			.map(m => this.getMethodDisplayName(m))
			.join(', ');
	}

	setupNewMethod(): void {
		this.dialogRef.close({ action: 'enroll' } as MfaMethodDisabledResult);
	}

	continueToPortal(): void {
		this.dialogRef.close({ action: 'continue' } as MfaMethodDisabledResult);
	}

	// F-132: an always-available exit. When the customer is Enforced and no method is enrollable, neither
	// "Set up a new method" nor "Continue to portal" renders and disableClose kills Escape/backdrop, so the
	// only interactive element was the mailto link — the user had to close the tab. Signing out grants no
	// portal access, so it does not weaken the Enforced policy; it just stops the session being unleavable.
	signOut(): void {
		this.dialogRef.close({ signedOut: true } as MfaMethodDisabledResult);
	}

	private getMethodDisplayName(method: string): string {
		switch (method) {
			case 'EmailOtp': return 'Email OTP';
			case 'AuthenticatorApp': return 'Authenticator App';
			default: return method;
		}
	}
}
